(function () {
  "use strict";

  var button = document.querySelector("[data-jst-back-to-top]");
  if (!button) return;

  var progressRing = button.querySelector("[data-jst-back-to-top-progress]");
  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  var frame = 0;

  if (window.self !== window.top) button.classList.add("is-embedded-preview");

  function update() {
    frame = 0;
    var root = document.documentElement;
    var scrollTop = window.scrollY || root.scrollTop || 0;
    var scrollable = Math.max(root.scrollHeight - window.innerHeight, 1);
    var progress = Math.min(100, Math.max(0, scrollTop / scrollable * 100));
    var threshold = Math.min(720, Math.max(420, window.innerHeight * 0.72));

    button.classList.toggle("is-visible", scrollTop > threshold);
    button.setAttribute("aria-hidden", scrollTop > threshold ? "false" : "true");
    button.tabIndex = scrollTop > threshold ? 0 : -1;
    if (progressRing) progressRing.style.strokeDashoffset = (100 - progress).toFixed(2);
  }

  function schedule() {
    if (frame) return;
    frame = window.requestAnimationFrame(update);
  }

  button.addEventListener("click", function (event) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: reducedMotion.matches ? "auto" : "smooth" });
  });

  window.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener("resize", schedule, { passive: true });
  update();
})();
